<template>
  <v-sheet
    class="d-flex flex-column pa-3 mb-2 mb-md-0 sheet"
    :style="{ width: width ? width : '240px' }"
  >
    <div class="mb-2 title">{{ title }}</div>
    <ul
      v-if="items && Object.keys(items).length > 0"
      style="overflow-y: auto"
    >
      <li
        v-for="(item, i) in items"
        :key="'type-' + i"
        class="d-flex flex-wrap justify-space-between mb-1"
      >
        <div class="pr-5 text">{{ item.label }}</div>
        <router-link
          v-if="isFilterable && hasConversions(item.value)"
          :to="getFilterLink(item)"
          class="text-value text-value--clickable"
          :style="{ color: $vuetify.theme.global?.current?.colors.primary }"
        >
          {{ item.value?.toLocaleString() || 0 }}
        </router-link>
        <div
          v-else
          class="text-value"
          :style="{ color: $vuetify.theme.global?.current?.colors.primary }"
        >
          {{ item.value?.toLocaleString() || 0 }}
        </div>
      </li>
    </ul>
    <div v-else>{{ t('dashboard.details.no-data') }}</div>
  </v-sheet>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  width: String,
  title: String,
  items: Object as PropType<Record<string, any>>,
})

const isFilterable = computed(() => props.title?.startsWith('utm-') || props.title === 'source')

const hasConversions = (item: string) => {
  const convertedValue = parseInt(item.split(' / ')[0]) || 0
  return convertedValue > 0
}

function getFilterLink(item) {
  if (!isFilterable.value) return ''

  const query: { [key: string]: string } = {}

  if (props.title?.startsWith('utm-')) {
    // Capitalize first letter after 'utm'
    const formattedParamName = props.title.replace(
      /^utm-([a-z])/,
      (_, c) => `utm${c.toUpperCase()}`
    )
    query[formattedParamName] = item.label
  } else if (props.title === 'source') {
    // Map source values to filter values
    const sourceMap = {
      facebook: 'facebook',
      google: 'google',
      qrCode: 'qrCode',
    }
    query.source = sourceMap[item.label] || item.label
  }

  return {
    path: '/leads',
    query,
  }
}
</script>

<style scoped>
.sheet {
  background: #eef4f4;
  border-radius: 10px;
  min-width: 230px;
  border-radius: 10px;
}

.title,
.text {
  font-size: 14px;
  font-style: normal;
  line-height: 18px;
}

.title {
  font-weight: 700;
}
.text {
  font-weight: 400;
  max-width: 195px;
}
.text-value {
  font-size: 18px;
  text-decoration: none;
}
.text-value--clickable {
  cursor: pointer;
}
.text-value--clickable:hover {
  text-decoration: underline;
}
</style>
